export const RESOURCES_API_URL =
  "https://api.sampleapis.com/codingresources/codingResources";
